import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = () => import('../views/pc/home/home.vue') // 首页
const Mail = () => import('../views/pc/mail/mail') // 董事长信箱
const CustomerCase = () => import('../views/pc/customerCase/customerCase');//客户案例
const CustomerCaseDetail = () => import('../views/pc/customerCase/customerCaseDetail');//客户案例详情
const LogisticsService = () => import('../views/pc/logisticsService/index') // 物流装备服务
const FinancialService = () => import('../views/pc/financialService/index') // 金融服务
const BuyFinancial = () => import('../views/pc/financialService/buyFinancial') // 金融服务--购车金融
const TheCarFinancial = () => import('../views/pc/financialService/theCarFinancial') // 金融服务--用车金融
const ProductValueAdded = () => import('../views/pc/financialService/productValueAdded') // 金融服务--产品增值
const LotService = () => import('../views/pc/lotService/index') // lot服务
const NewsCenter = () => import('../views/pc/newsCenter/index') //新闻中心
const NewsCenterDetail = () => import('../views/pc/newsCenter/detail') //新闻中心--详情页
const PCPage = () => import('../views/pcPage') // Pc
const AboutUs = () => import('../views/pc/aboutUs/aboutUs') // 关于我们
const Abstract = () => import('../views/pc/aboutUs/abstract') // 关于我们--企业简介
const JoinUs = () => import('../views/pc/aboutUs/joinUs') // 关于我们--加入我们
const TeamManage = () => import('../views/pc/aboutUs/teamManage') // 团队管理

export default new Router({
  mode: 'history',
  base: "/",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/mail',
      name: 'Mail',
      component: Mail
    },
    {
      path: '/customerCase',
      name: 'CustomerCase',
      component: CustomerCase,
    },
    {
      path: '/customerCaseDetail',
      name: 'CustomerCaseDetail',
      component: CustomerCaseDetail,
    },
    {
      path: '/logisticsService',
      name: 'LogisticsService',
      component: LogisticsService
    },
    {
      path: '/financialService',
      name: 'FinancialService',
      component: FinancialService,
      children: [
        {
          path: '/buyFinancial',
          name: 'BuyFinancial',
          component: BuyFinancial
        },
        {
          path: '/theCarFinancial',
          name: 'TheCarFinancial',
          component: TheCarFinancial
        },
        {
          path: '/productValueAdded',
          name: 'ProductValueAdded',
          component: ProductValueAdded
        }
      ]
    },
    {
      path: '/lotService',
      name: 'LotService',
      component: LotService
    },
    {
      path: '/newsCenter',
      name: 'NewsCenter',
      component: NewsCenter,
    },
    {
      path: '/newsCenterDetail',
      name: 'NewsCenterDetail',
      component: NewsCenterDetail,
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs,
      children: [
        {
          path: '/abstract',
          name: 'Abstract',
          component: Abstract
        },
        {
          path: '/teamManage',
          name: 'TeamManage',
          component: TeamManage
        },
        {
          path: '/joinUs',
          name: 'JoinUs',
          component: JoinUs
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js